import type { CandidateSearchRequestDto, CandidatesSearchResponseDto } from '@/api/generated';

import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Req = {
  adminUserId: string;
  dto: CandidateSearchRequestDto;
  page: number;
  pageSize: number;
};

type Response = CandidatesSearchResponseDto;

type Return = {
  getCandidates: (req: Req) => Promise<Response>;
  isGetting: boolean;
};

export const useGetCandidates = (): Return => {
  const { adminCandidatesApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const { data } = await adminCandidatesApi.getCandidates(
        req.page,
        req.pageSize,
        req.adminUserId,
        req.dto,
      );
      return data;
    },
  });

  return {
    getCandidates: mutateAsync,
    isGetting: isPending,
  };
};
